<template>
    <div>
        <van-nav-bar
                title="出库查询"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />
        <!--            z-index="9999"-->
        <van-nav-bar
                title="提单详情"
                left-arrow
                fixed
                v-if="showpop"
                @click-left="showpop=false"
                z-index="9999"
        />
        <van-button v-if="showpop" class="closebutton" block size="small" type="info" native-type="submit"
                    style="font-size: 16px;width:100%;margin:auto" @click="closeShow()">
            关闭
        </van-button>
        <van-nav-bar
                title="提单明细"
                left-arrow
                fixed
                v-if="showDetailpop"
                @click-left="showDetailpop=false"
                z-index="9999"
        />
        <van-button v-if="showDetailpop" class="closebutton" block size="small" type="info" native-type="submit"
                    style="font-size: 16px;width:100%;margin:auto" @click="closeDetailShow()">
            关闭
        </van-button>

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!--                    <van-swipe-cell>-->
                    <van-cell v-for="item in list" :key="item.id" class="swipewarp">
                        <van-row gutter="20">
                            <van-col span="14" style="">货主提单号：{{item.outnotifyCustomerNo}}</van-col>
                            <van-col span="10" style="text-align: right;word-break:keep-all;white-space:nowrap;">
                                出库日期：{{item.outstockDate |moment("YY-MM-DD")}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="color: #727272">
                            <van-col>品名：{{item.cargoName}} {{item.cargoMaterialName}} {{item.cargoModelName}}
                                {{item.cargoOriginName}}
                            </van-col>
                        </van-row>
                        <!--<van-row gutter="20">-->
                        <!--<van-col span="14" style="">货主提单号：{{item.outnotifyCustomerNo}}</van-col>-->
                        <!--</van-row>-->
                        <van-row gutter="20" style="color: #727272">
                            <van-col span="10" style="">提货车号：{{item.truckNo}}</van-col>
                            <van-col span="14" style="text-align: right">出库数量：{{item.actAmount}}件，{{item.actWeight}}吨
                            </van-col>
                            <!--<van-col span="10" style="text-align: right">{{item.cargoMaterialName}}</van-col>-->
                        </van-row>
                        <!--<van-row gutter="20" style="color: #727272">-->
                        <!--<van-col span="14" style="word-break:keep-all;white-space:nowrap;">{{item.cargoModelName}}</van-col>-->
                        <!--<van-col span="10" style="text-align: right">{{item.cargoOriginName}}</van-col>-->
                        <!--</van-row>-->
                        <!--<van-row gutter="20" style="color: #727272">-->

                        <!--<van-col span="14" style="word-break:keep-all;white-space:nowrap;">{{item.amount}}</van-col>-->
                        <!--<van-col span="10" style="text-align: right">{{item.weight}}</van-col>-->
                        <!--</van-row>-->
                        <!--<van-row gutter="20" style="color: #727272">-->
                        <!--<van-col span="14" style="word-break:keep-all;white-space:nowrap;">{{item.wcode?item.wcode+"/":''}}{{item.acode?item.acode+"/":''}}{{item.pcode}}</van-col>-->
                        <!--</van-row>-->

                    </van-cell>
                    <!--                        <template #right>-->
                    <!--                            <van-button plain  type="danger" text="删除" @click="remove(item.id)"/>-->
                    <!--                        </template>-->
                    <!--                    </van-swipe-cell>-->

                </van-list>
            </van-pull-refresh>
        </div>
        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.key1" label="出库单号" placeholder="出库单号/货主提单号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.key2" label="入库卡号" placeholder="入库卡号/车船箱号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <!--<van-field v-model="searchValue.batchNumber" label="批号"  placeholder="批号"  autocomplete="off"  label-width="60px"/>-->
                <van-field v-model="searchValue.from" label="出库日期" readonly="readonly" placeholder="点击选择日期"
                           autocomplete="off" @click="calendarShow=true" label-width="80px" label-align="right"/>
                <!--<van-field name="radio" label="锁仓类型">-->
                <!--<template #input>-->
                <!--<van-radio-group v-model="searchValue.freezeType" direction="horizontal">-->
                <!--<van-radio name="10">云商</van-radio>-->
                <!--<van-radio name="20">配货</van-radio>-->
                <!--<van-radio name="30">未锁</van-radio>-->
                <!--</van-radio-group>-->
                <!--</template>-->
                <!--</van-field>-->
                <van-field :value="selcargoName" readonly name="picker" label="品名" placeholder="点击选择品名"
                           @click="showPicker = true" label-width="80px" label-align="right"/>
                <van-field :value="selcargoMaterName" readonly name="picker" label="材质" placeholder="点击选择材质"
                           @click="showPickerMater = true" label-width="80px" label-align="right"/>
                <van-field :value="selcargoModelName" readonly name="picker" label="规格" placeholder="点击选择规格"
                           @click="showPickerModel = true" label-width="80px" label-align="right"/>
                <van-field :value="selcargoOrnName" readonly name="picker" label="品牌" placeholder="点击选择品牌"
                           @click="showPickerPP = true" label-width="80px" label-align="right"/>

                <van-popup v-model="showPicker" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品名"
                            show-toolbar
                            :columns="cargocol"
                            @confirm="selCargoId"
                            @cancel="showPicker = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerMater" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="材质"
                            show-toolbar
                            :columns="cargoMatercol"
                            @confirm="selCargoMaterId"
                            @cancel="showPickerMater = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerModel" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="规格"
                            show-toolbar
                            :columns="cargoModelcol"
                            @confirm="selCargoModelId"
                            @cancel="showPickerModel = false"
                    />
                </van-popup>
                <van-popup v-model="showPickerPP" position="bottom" :style="{ height: '310px' }">
                    <van-picker
                            title="品牌"
                            show-toolbar
                            :columns="cargoOrncol"
                            @confirm="selCargoOrgnId"
                            @cancel="showPickerPP = false"
                    />
                </van-popup>
                <!--<van-field name="" label="仓库" label-width="60px">-->
                <!--<van-dropdown-menu>-->
                <!--<van-dropdown-item @change="selWaaId()" v-model="searchValue.warehouseId" :options="wData" />-->
                <!--</van-dropdown-menu>-->
                <!--</van-field>-->
                <!--<van-field :value="selWcode" readonly name="picker" label="仓库"   placeholder="点击选择仓库"  @click="showPickerCK = true" />-->
                <!--<van-picker-->
                <!--title="仓库"-->
                <!--v-if="showPickerCK"-->
                <!--show-toolbar-->
                <!--:columns="cargocolCK"-->
                <!--@confirm="selWaaId"-->
                <!--@cancel="showPickerCK = false"-->
                <!--/>-->
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              :default-date="[new Date((new Date()-30000*60*60*24)),new Date() ]"
                              type="range" @confirm="calendarConfirm"/>
            </div>
        </van-popup>
        <van-popup v-model="showDetailpop" position="right" :style="{ height: '100%', width:'100%'}">
            <van-nav-bar
                    title="提单明细"
                    left-arrow
                    fixed
                    @click-left="showDetailpop=false"
                    z-index="9999"
            />
            <div class="editwarp">
                <van-cell class="swipewarp">
                    <div v-for="(item,index) in outnotifyDetail" :key="item.id">
                        <van-row gutter="20">
                            <van-col span="14">
                                {{item.cargoName}}\{{item.materialName}}\{{item.modelName}}\{{item.originName}}
                            </van-col>
                            <van-col span="10" style="text-align: right"></van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="14">{{item.cargoFactmodel}}\{{item.batchNumber}}</van-col>
                            <van-col span="10" style="text-align: right">
                                {{item.wCode}}\{{item.aCode}}\{{item.pCode}}\{{item.layer}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="14">应发：{{item.amount}}<span style="margin-left: 3px">件</span>，{{item.weight}}<span
                                    style="margin-left: 3px">吨</span></van-col>
                            <van-col span="10" style="text-align: right">实发：{{item.amountOut}}<span
                                    style="margin-left: 3px">件</span>，{{item.weightOut}}<span
                                    style="margin-left: 3px">吨</span></van-col>
                        </van-row>

                        <van-divider v-if="(index+1)!=outnotifyDetail.length"
                                     :style="{ color: '#c2c2c2', borderColor: '#c2c2c2', padding: '10px 0 10px 0' }"/>
                    </div>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {Picker, NavBar, Toast, Cell, Button, Icon, Field, Dialog} from 'vant';
    import {Form} from 'vant';
    import {List} from 'vant';
    import {Search} from 'vant';
    import {Col, Row} from 'vant';
    import {SwipeCell} from 'vant';
    import {Popup} from 'vant';
    import {PullRefresh} from 'vant';
    import {Sticky} from 'vant';
    import {RadioGroup, Radio} from 'vant';
    import {Calendar} from 'vant';
    import {Divider} from 'vant';
    import {Lazyload} from 'vant';
    import service from '../../server/index'
    import {Image as VanImage} from 'vant';
    import {ImagePreview} from 'vant';
    import {Grid, GridItem} from 'vant';
    import QRCode from 'qrcodejs2';
    // Vue.use(Lazyload);

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {
            showStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else {
                        if (item.balanceStatus == 0) {
                            return "unpay";
                        } else {
                            return "pay"
                        }
                    }
                }
            },
            showDetailStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else if (item.status == 20) {
                        return "verify"
                    }
                }
            },
            showMoney() {
                return function (cash) {
                    return Math.round((cash + Number.EPSILON) * 100) / 100;
                }
                // cash.toFixed(2);
                // return Math.round((cash + Number.EPSILON) * 100) / 100;
                // return cash.toFixed(2);
            }
        },
        data() {
            return {
                value: "",
                show: true,//nav bar
                showtitle: false,
                ershow: false,
                qrcodeContent: "",
                title: "",
                list: [],
                loading: true,
                finished: false,
                showpop: false,
                searchValue: {},
                selcargoName: "",
                selcargoMaterName: "",
                selcargoModelName: "",
                cargoData: [],
                cargocol: [],
                cargoMatercol: [],
                cargoModelcol: [],
                selcargoOrnName: "",
                cargoOrnData: [],
                cargoModelData: [],
                cargoMaterData: [],
                cargoOrncol: [],
                showPickerPP: false,
                showPicker: false,
                showPickerMater: false,
                showPickerModel: false,
                selWcode: "",
                wodeData: [],
                cargocolCK: [],
                showPickerCK: false,
                searchShowPop: false,
                //编辑
                info: {
                    "outnotifyNo": "",
                    "balanceAmount": "",
                    "customerName": "",
                    "outnotifyCustomerNo": "",
                    "status": "",
                    "balanceStatus": "",
                    "cargo": [
                        {
                            "cargoName": "",
                            "amount": "",
                            "weight": ""
                        }
                    ]
                },
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                //提单详情
                outnotify: {
                    // outnotifyNo:"OU0923131",
                    // outnotifyDate:"2020-10-10",
                    // customerName:"无锡太钢",
                    // outnotifyCustomerNo:"TH0019-11",
                    // balanceAmount:"32.00",
                    // status:30,
                    // balanceStatus:"1",
                    // cargo:[
                    //     {
                    //         cargoName:"铝锭",
                    //         amount:"11",
                    //         weight:"13.1213",
                    //         amountOut:"11",
                    //         weightOut:"13.1213",
                    //     },
                    //     {
                    //         cargoName:"不锈钢板",
                    //         amount:"11",
                    //         weight:"13.1213",
                    //         amountOut:"11",
                    //         weightOut:"13.1213",
                    //     }
                    // ],
                    warrantyBook: [
                        //   "https://img.yzcdn.cn/vant/apple-1.jpg",
                        //     "https://img.yzcdn.cn/vant/apple-2.jpg",
                        //     "https://img.yzcdn.cn/vant/apple-3.jpg",
                        //     "https://img.yzcdn.cn/vant/apple-4.jpg"
                    ]
                },
                //提货明细
                outnotifyDetail: [
                    {
                        id: "1",
                        cargoName: "铝锭",
                        materialName: "99.0",
                        modelName: "Q235B",
                        originName: "太钢",
                        cargoFactmodel: "SJ规格",
                        batchNumber: "123123",
                        pCode: "W10",
                        layer: "11",
                        amount: "1",
                        weight: "1",
                        amountOut: "0",
                        weightOut: "0"
                    },
                    {
                        id: "2",
                        cargoName: "铝锭",
                        materialName: "99.0",
                        modelName: "Q235B",
                        originName: "太钢",
                        cargoFactmodel: "SJ规格",
                        batchNumber: "123123",
                        pCode: "W10",
                        layer: "11",
                        amount: "1",
                        weight: "1",
                        amountOut: "0",
                        weightOut: "0"
                    },
                    {
                        id: "3",
                        cargoName: "铝锭",
                        materialName: "99.0",
                        modelName: "Q235B",
                        originName: "太钢",
                        cargoFactmodel: "SJ规格",
                        batchNumber: "123123",
                        pCode: "W10",
                        layer: "11",
                        amount: "1",
                        weight: "1",
                        amountOut: "0",
                        weightOut: "0"
                    }
                ],
                showDetailpop: false,
                showWarrantypop: false
            }
        },
        mounted() {
            this.onLoad();

            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selOuCargoG(parm).then(res => {
                let data = res.data;
                this.cargoData = data
                for (let i = 0; i < data.length; i++) {

                    this.cargocol.push(data[i].cargoName)
                }

            })
            service.selWarehouseG(parm).then(res => {
                let data = res.data;
                this.wodeData = data
                for (let i = 0; i < data.length; i++) {

                    this.cargocolCK.push(data[i].wcode)
                }
            })
        },
        methods: {
            back() {
                this.$router.replace("/Home/Search")
            },
            selCargoId(value, index) {
                this.selcargoName = value;
                this.searchValue.cargoId = this.cargoData[index].cargoId
                this.showPicker = false;
                let parm = {};
                parm.ouid = localStorage.getItem("ouid")
                parm.cargoId = this.cargoData[index].cargoId
                service.selCargoMaterialG(parm).then(res => {
                    let data = res.data;
                    this.cargoMaterData = data
                    this.cargoMatercol = []
                    for (let i = 0; i < data.length; i++) {
                        this.cargoMatercol.push(data[i].cargoMaterialName)
                    }
                    this.selcargoMaterName = ""
                    this.searchValue.cargoMaterialId = ""
                })
                service.selCargoModelG(parm).then(res => {
                    let data = res.data;
                    this.cargoModelData = data
                    this.cargoModelcol = []
                    for (let i = 0; i < data.length; i++) {

                        this.cargoModelcol.push(data[i].cargoModelName)
                    }
                    this.selcargoModelName = ""
                    this.searchValue.cargoModelId = ""
                })
                service.selCargoOriginG(parm).then(res => {
                    let data = res.data;
                    this.cargoOrnData = data
                    this.cargoOrncol = []
                    for (let i = 0; i < data.length; i++) {

                        this.cargoOrncol.push(data[i].cargoOriginName)
                    }
                    this.selcargoOrnName = ""
                    this.searchValue.cargoOriginId = ""
                })
            },
            selWaaId(value, index) {
                this.selWcode = value;
                this.searchValue.warehouseId = this.wodeData[index].warehouseId
                this.showPickerCK = false;
            },
            selCargoOrgnId(value, index) {
                this.selcargoOrnName = value;
                this.searchValue.cargoOriginId = this.cargoOrnData[index].cargoOriginId
                this.showPickerPP = false;
            },
            selCargoModelId(value, index) {
                this.selcargoModelName = value;
                this.searchValue.cargoModelId = this.cargoModelData[index].cargoModelId
                this.showPickerModel = false;
            },
            selCargoMaterId(value, index) {
                this.selcargoMaterName = value;
                this.searchValue.cargoMaterialId = this.cargoMaterData[index].cargoMaterialId
                this.showPickerMater = false;
            },
            shower(data) {
                document.getElementById("qrCode").innerHTML = " ";
                //1.获取当前日期
                let m = new Date();

                let n = new Date(m.getTime() + 1000 * 60);
                let date = this.$moment(n).format("YYYY-DD-MM hh:mm:ss");

                let par = [];

                let o = {};
                o.bussionType = data.bussionType
                o.ouid = data.ouid
                // o.bussionNo=data.outnotifyId;
                o.userId = localStorage.getItem("userId");
                o.endTime = date
                par.push(o)
                let str = JSON.stringify(par);
                console.log(str);
                this.qrcodeContent = this.encode64(str)
                this.bindQRCode();

                this.ershow = true
            },
            encode64(input) {
                // base64加密开始
                let keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv"
                    + "wxyz0123456789+/" + "=";
                let output = "";
                let chr1, chr2, chr3 = "";
                let enc1, enc2, enc3, enc4 = "";
                let i = 0;
                do {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);
                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }
                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
                        + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                } while (i < input.length);

                return output;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.showtitle = false;
                this.show = true;
                this.searchShowPop = false;
                this.onLoad();
            },
            bindQRCode() {
                new QRCode(this.$refs.qrCodeDiv, {
                    text: this.qrcodeContent,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })

            },
            onLoad() {
                if (this.searchValue.startDate == null && this.searchValue.endDate == null) {
                    this.searchValue.startDate = new Date((new Date() - 30000 * 60 * 60 * 24))
                    this.searchValue.endDate = new Date()
                }
                let param = this.searchValue
                param.size = this.pageSize
                param.page = this.page
                param.ouid = localStorage.getItem("ouid")
                // param.groupType='byCarogo'
                param.customerId = localStorage.getItem("customerId")
                service.selOutstockTotal(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        console.log(this.list)
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                }).catch((res) => {
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            searchPop() {
                this.show = true;
                // this.showtitle = false;
                // this.title = "筛选";
                // this.searchValue= {keywords:"", from:"", to:"", status:"0"};
                this.searchShowPop = true;
            },
            showBill(item) {
                this.outnotify = item
                this.showpop = true;
            },
            closeShow() {
                if (this.ershow) {
                    this.ershow = false
                } else {
                    this.showpop = false;
                    this.show = true;
                }

            },
            onRefresh() {
                this.onLoad();

            },
            remove(id) {
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要删除这条车辆信息吗？',
                    confirmButtonColor: "#6685a4"
                })
                    .then(() => {
                        let param = {
                            "deliveryTruckId": id,
                        }
                        service.deleteTruck(param).then((res) => {
                            if (res.code == "200") {
                                this.showpop = false;
                                this.page = 1;
                                this.list = [];
                                this.onLoad();
                            } else {
                                Toast(res.msg)
                            }

                        }).catch((res) => {
                            Toast(res.message)
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.endDate = this.$moment(end).format("YYYY-MM-DD");

            },
            resetSearch() {
                this.searchValue = {};
                this.selcargoName = "";
                this.selcargoOrnName = "";
                this.selcargoModelName = "";
                this.selcargoMaterName = "";
                this.selWcode = ""
            },
            showDetail() {
                this.showDetailpop = true;
                this.title = "提货明细"
                let param = {
                    outnotifyId: this.outnotify.outnotifyId
                };
                service.ladingBillDetail(param).then((res) => {
                    this.outnotifyDetail = res.data;
                })
            },
            closeDetailShow() {
                this.showDetailpop = false;
                this.title = "提货详情"
            },
            showWarrantyBook() {
                this.showWarrantypop = true;
                this.title = "质保书"
            },
            closeWarrantyShow() {

                this.showWarrantypop = false;
                this.title = "提货详情"


            },
            showImg(item) {
                ImagePreview([item]);
            },
            closeCurrentPage() {

            }
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 50px);
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }
</style>